import React, { useState } from "react";

function ToolMessage({ data, result }) {
  const [expanded, setExpanded] = useState(false);

  if (!data || typeof data === "string") {
    return <span>{data}</span>;
  }

  switch (data.type) {
    case "read":
      return (
        <div className="tool-msg tool-msg-read">
          <span className="tool-icon">📖</span>
          <span className="tool-path">{data.path}</span>
          {data.startLine && (
            <span className="tool-lines">
              lines {data.startLine}-{data.endLine}
            </span>
          )}
        </div>
      );

    case "edit": {
      const success = result?.success !== false;
      const errorMsg = result?.error;

      return (
        <div
          className={`tool-msg tool-msg-edit ${!success ? "tool-msg-error" : ""}`}
        >
          <div className="tool-header" onClick={() => setExpanded(!expanded)}>
            <span className="tool-icon">{success ? "✏️" : "⚠️"}</span>
            <span className="tool-path">{data.path}</span>
            {!success && <span className="tool-failed-label">Failed</span>}
            <span className="tool-toggle">{expanded ? "▼" : "▶"}</span>
          </div>
          {expanded &&
            (success ? (
              <div className="tool-diff">
                <div className="tool-diff-remove">
                  <span className="diff-marker">−</span>
                  <pre>{data.find}</pre>
                </div>
                <div className="tool-diff-add">
                  <span className="diff-marker">+</span>
                  <pre>{data.replace}</pre>
                </div>
              </div>
            ) : (
              <div className="tool-error-details">
                <div className="tool-error-msg">{errorMsg}</div>
                <div className="tool-error-searched">
                  <span className="tool-error-label">Searched for:</span>
                  <pre>{data.find}</pre>
                </div>
              </div>
            ))}
        </div>
      );
    }

    case "write":
      return (
        <div className="tool-msg tool-msg-write">
          <span className="tool-icon" aria-hidden>
            <svg
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8939 20.0214L10.5351 14.9503M10.5351 14.9503L8.02566 17.1756L8.59407 7.70584L13.8212 15.6227L10.5351 14.9503ZM3.01793 14.6832C-0.203894 11.4614 -0.203894 6.2378 3.01793 3.01598C6.23976 -0.205847 11.4634 -0.205847 14.6852 3.01598C16.2961 4.62685 17.1015 6.73815 17.1016 8.84946M5.13925 12.5619C3.089 10.5117 3.089 7.18755 5.13925 5.1373C7.1895 3.08705 10.5136 3.08705 12.5639 5.1373C13.589 6.16241 14.1015 7.50598 14.1016 8.84955"
                stroke="#CC9A05"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="tool-path">{data.path}</span>
        </div>
      );

    case "inspect_styles":
      return (
        <div className="tool-msg tool-msg-inspect">
          <span className="tool-icon" aria-hidden>
            <svg
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8939 20.0214L10.5351 14.9503M10.5351 14.9503L8.02566 17.1756L8.59407 7.70584L13.8212 15.6227L10.5351 14.9503ZM3.01793 14.6832C-0.203894 11.4614 -0.203894 6.2378 3.01793 3.01598C6.23976 -0.205847 11.4634 -0.205847 14.6852 3.01598C16.2961 4.62685 17.1015 6.73815 17.1016 8.84946M5.13925 12.5619C3.089 10.5117 3.089 7.18755 5.13925 5.1373C7.1895 3.08705 10.5136 3.08705 12.5639 5.1373C13.589 6.16241 14.1015 7.50598 14.1016 8.84955"
                stroke="#CC9A05"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span>
            Finding styles for{" "}
            <code className="tool-selector">{data.selector}</code>
          </span>
        </div>
      );

    case "inspect_dom":
      return (
        <div className="tool-msg tool-msg-inspect">
          <span className="tool-icon" aria-hidden>
            <svg
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8939 20.0214L10.5351 14.9503M10.5351 14.9503L8.02566 17.1756L8.59407 7.70584L13.8212 15.6227L10.5351 14.9503ZM3.01793 14.6832C-0.203894 11.4614 -0.203894 6.2378 3.01793 3.01598C6.23976 -0.205847 11.4634 -0.205847 14.6852 3.01598C16.2961 4.62685 17.1015 6.73815 17.1016 8.84946M5.13925 12.5619C3.089 10.5117 3.089 7.18755 5.13925 5.1373C7.1895 3.08705 10.5136 3.08705 12.5639 5.1373C13.589 6.16241 14.1015 7.50598 14.1016 8.84955"
                stroke="#CC9A05"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span>
            {data.action === "tree" ? (
              "Reading page structure"
            ) : (
              <>
                Finding <code className="tool-selector">{data.selector}</code>
              </>
            )}
          </span>
        </div>
      );

    default:
      return <span>{JSON.stringify(data)}</span>;
  }
}

export default ToolMessage;
